import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/http/data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TransfertService extends DataService {
  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  create(data: any) {
    return this.post(data, '?ctrl=transfert&action=creer');
  }
  supprimer(id: any) {
    return this.delete(id, '?ctrl=transfert&action=supprimer');
  }

  updateTransfert(data: any) {
    return this.update(data, '?ctrl=transfert&action=modifier');
  }

  calculer(data: any) {
    return this.post(data, '?ctrl=transfert&action=calculer');
  }

  compteur(data: any) {
    return this.post(data, '?ctrl=transfert&action=compteur');
  }

}
